import { makeStyles } from '@material-ui/core/styles'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'
import { CircularProgress, IconButton, Menu, MenuItem } from '@material-ui/core'
import React, { useState } from 'react'
import { useParams } from 'react-router'
import {
  ArrowRightIcon,
  KebabVerticalIcon,
  UserSimplifiedIcon
} from 'asterX-UI/Icons'
import { GRAY_COLORS } from 'asterX-UI'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { Modal } from 'asterX-UI/Modals'
import ClientPage from './ClientPage'
import UserComments from './UserComments'
import QrScanner from 'components/QrScanner'
import { CarService } from 'lib/api'
import { useResErrors } from 'hooks'

const STEPS_TITLES = [
  {
    title: 'Подбор авто',
    sub: 'Демонстрация'
  },
  {
    title: 'Демонстрация',
    sub: 'Выбор авто'
  },
  {
    title: 'Выбор авто',
    sub: 'Оформление'
  },
  {
    title: 'Оформление'
  }
]

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  progressCircle: {
    position: 'relative',
    display: 'inline-flex',
    marginRight: 22
  },
  circleBottom: {
    color: GRAY_COLORS['200']
  },
  circleTop: {
    position: 'absolute',
    left: 0
  },
  circleText: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 500
  },
  stepInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center ',
    marginRight: 'auto',
    position: 'relative'
  },
  mainInfo: {
    fontSize: 16,
    fontWeight: 600,
    paddingLeft: 5
  },
  subInfo: {
    display: 'flex',
    alignItems: 'center',
    color: '#98A2B3',
    fontSize: 12
  },
  kebab: {
    marginRight: 12
  },
  arr: {
    fontSize: 20
  }
}))

const CarSelectionHeader = () => {
  const {
    funcs: { goPrevStep, handleSelectCar }
  } = useSelectionStore()
  const classes = useStyles()
  const { step } = useParams()
  const { standardCheck } = useResErrors()
  const [anchorEl, setAnchorEl] = useState(null)
  const [isCommentsPageOpen, setIsCommentsPageOpen] = useState(false)
  const [qrOpen, setQrOpen] = useState(false)
  const [isClientPageOpen, setIsClientPageOpen] = useState(false)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = () => {
    setAnchorEl(null)
  }
  const handleUserClick = () => {
    setIsClientPageOpen(!isClientPageOpen)
  }
  const handleCommentsClick = () => {
    setIsCommentsPageOpen(!isCommentsPageOpen)
  }
  const handleOpenQrClick = () => {
    setQrOpen(!qrOpen)
    handleCloseMenu()
  }
  const onScanSuccess = async data => {
    if (typeof data === 'string' && data.includes('catalog/')) {
      const productCode = data.split('/').at(4)
      await CarService.getCarByProductCode(productCode).then(async res =>
        standardCheck(res, async () => {
          await CarService.getCarByVin(res.data.vin).then(r =>
            standardCheck(r, () => {
              handleSelectCar(r.data)
            })
          )
        })
      )
    }
  }

  return (
    <div className={classes.container}>
      <IconButton
        style={{
          color: GRAY_COLORS[400]
        }}
        onClick={goPrevStep}
        size={'medium'}
      >
        <ChevronLeftIcon />
      </IconButton>
      <div className={classes.progressCircle}>
        <CircularProgress
          variant="determinate"
          value={100}
          size={54}
          className={classes.circleBottom}
        />
        <CircularProgress
          variant="determinate"
          value={(Number(step) + 1) * 25}
          size={54}
          className={classes.circleTop}
        />
        <div className={classes.circleText}>{`${Number(step) + 1} из 4`}</div>
      </div>

      <div className={classes.stepInfo}>
        <div className={classes.mainInfo}>
          {STEPS_TITLES[Number(step)]?.title}{' '}
        </div>

        {STEPS_TITLES[Number(step)]?.sub && (
          <div className={classes.subInfo}>
            <ArrowRightIcon className={classes.arr} />
            {STEPS_TITLES[Number(step)]?.sub}
          </div>
        )}
      </div>

      <IconButton aria-controls="header-dropdown" onClick={handleClick}>
        <KebabVerticalIcon />
      </IconButton>

      <IconButton onClick={handleUserClick}>
        <UserSimplifiedIcon />
      </IconButton>

      <Menu
        id="header-dropdown"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
      >
        <MenuItem
          onClick={() => {
            handleCommentsClick()
            handleCloseMenu()
          }}
        >
          Коментарии
        </MenuItem>
        {[0, 1].includes(Number(step)) && (
          <MenuItem onClick={handleOpenQrClick}>
            Добавить авто через QR
          </MenuItem>
        )}
      </Menu>
      {isClientPageOpen && (
        <Modal
          fullWidth
          maxWidth={'md'}
          open={isClientPageOpen}
          onClose={() => setIsClientPageOpen(false)}
        >
          <ClientPage onClose={handleUserClick} />
        </Modal>
      )}
      <Modal
        fullWidth
        maxWidth={'md'}
        open={isCommentsPageOpen}
        onClose={() => setIsCommentsPageOpen(false)}
      >
        <UserComments onClose={handleCommentsClick} />
      </Modal>
      {qrOpen && (
        <QrScanner
          open={qrOpen}
          isDesk
          onClose={handleOpenQrClick}
          onSuccess={onScanSuccess}
        />
      )}
    </div>
  )
}

export default CarSelectionHeader
